module.exports = __webpack_public_path__ + "static/media/broadwayDinner.cb42bd47.pdf";